import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { approvedMessages, HouseholdStory, Messages, sharedStatus, SharedStatus } from '../../api/sharedHouseholdApi';
import { sharedLibraryRows } from '../../api/libraryPlayback';
import { BedtimePair } from '../../context/bedtime/bedtimeContextModel';
import ApprovedStoryActions from './ApprovedStoryActions';

export default function SharedStoryActions({ story, pair, messages, details = true }: { story: HouseholdStory; pair: BedtimePair; messages: Messages; details?: boolean }) {
  const [status, setStatus] = useState<SharedStatus | null>(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setStatus(null); setError(false);
    if (!story.candidate_id || story.narration_approved !== undefined) return;
    const controller = new AbortController();
    void sharedStatus(story.candidate_id, pair.listenerId, controller.signal, story.source_kind)
      .then(row => { if (!controller.signal.aborted) setStatus(row); })
      .catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [story, pair.listenerId, retry]);
  if (story.candidate_id && story.narration_approved === undefined && !status) {
    return error ? <button type="button" className="btn btn-secondary" onClick={() => setRetry(n => n + 1)}>Try again</button> : <span role="status">Checking saved story…</span>;
  }
  const current = status ? {...story, narration_approved: status.narration_approved, funding_ready: status.funding_ready} : story;
  const currentMessages = status?.messages || messages;
  const [row] = sharedLibraryRows({stories: [current], messages: currentMessages, component_review_policy: 'component-audio-v1'}, pair);
  if (row) return <ApprovedStoryActions story={row} title={story.title} details={details} />;
  const label = current.narration_approved && !approvedMessages(currentMessages) ? 'Finish personal messages' : current.narration_approved ? 'View saved story' : current.candidate_id ? 'Review story' : 'Open saved story';
  return <Link className="btn btn-primary" to={`/household-stories?story=${encodeURIComponent(story.story_id)}`}>{label}</Link>;
}
